import { z } from 'zod';

const MIN_LENGTH = 1;
const MAX_LENGTH = 1024;

const MAX_SEAT_COUNT = 1000;

const ALLOWED_CHARACTERS = /^[a-zA-Z0-9\u0E00-\u0E3A\u0E40-\u0E4E_:,()[\]\s-]+$/;
const ALLOWED_CHARACTERS_ERROR_MESSAGE =
  'ใช้ได้เฉพาะตัวอักษร ตัวเลข และอักขระพิเศษ _ : , ( ) [ ] - เท่านั้น';

export const ExamRoomCreateFormSchema = z.object({
  floor: z
    .string()
    .trim()
    .min(MIN_LENGTH, { message: 'กรุณากรอกชั้นห้องสอบ' })
    .max(MAX_LENGTH, {
      message: `ชั้นต้องมีความยาวไม่เกิน ${MAX_LENGTH} ตัวอักษร`,
    })
    .regex(ALLOWED_CHARACTERS, {
      message: ALLOWED_CHARACTERS_ERROR_MESSAGE,
    }),
  name: z
    .string()
    .trim()
    .min(MIN_LENGTH, { message: 'กรุณากรอกชื่อห้องสอบ' })
    .max(MAX_LENGTH, {
      message: `ชื่อห้องต้องมีความยาวไม่เกิน ${MAX_LENGTH} ตัวอักษร`,
    })
    .regex(ALLOWED_CHARACTERS, {
      message: ALLOWED_CHARACTERS_ERROR_MESSAGE,
    }),
  roomNumber: z
    .string()
    .or(z.literal(''))
    .refine((val) => val === '' || val.length <= MAX_LENGTH, {
      message: `เลขที่ห้องต้องมีความยาวไม่เกิน ${MAX_LENGTH} ตัวอักษร`,
    })
    .refine((val) => val === '' || ALLOWED_CHARACTERS.test(val), {
      message: 'อนุญาตเฉพาะ ก-ฮ, a-z, A-Z, 0-9 และเครื่องหมาย - _ : , () [ ] เท่านั้น',
    })
    .optional(),
  seatCount: z
    .union([z.string(), z.number()])
    .refine((val) => val !== '' && val !== null && val !== undefined, {
      message: 'กรุณาระบุจำนวนที่นั่ง',
    })
    .pipe(
      z.coerce
        .number({ invalid_type_error: 'กรุณาระบุจำนวนที่นั่งให้ถูกต้อง' })
        .min(1, { message: 'จำนวนที่นั่งต้องมีอย่างน้อย 1 ที่นั่ง' })
        .max(MAX_SEAT_COUNT, { message: `จำนวนที่นั่งต้องไม่เกิน ${MAX_SEAT_COUNT} ที่นั่ง` }),
    ),
});

export type ExamRoomCreateFormInput = z.infer<typeof ExamRoomCreateFormSchema>;
